import store from "../init/store.js";
import BattleActions from "./battle-data/battle-actions.js";
import { modelsFromObject } from "../helpers/models-from-object.js";

export function getTargets(actionId = "", combatantTeamId = "", casterId = "") {
  const model = BattleActions[actionId];

  if (!model) {
    console.warn("no action found", actionId);
  }
  if (!casterId) {
    console.warn("no casterId found in getTargets");
  }

  const combatants = store.getState().battle.combatants;

  /* Get allies and enemies. Allies  */

  const myTeam = modelsFromObject(combatants).filter(c => {
    return c.belongsToTeam === combatantTeamId;
  });
  const enemyTeam = modelsFromObject(combatants).filter(c => {
    return c.belongsToTeam !== combatantTeamId;
  });

  // const allFriendlyIds = myTeam.map(c => c._id);
  // const allEnemyIds = enemyTeam.map(c => c._id);

  const aliveFriendlyIds = myTeam.filter(c => c.isAlive()).map(c => c._id);
  const aliveEnemyIds = enemyTeam.filter(c => c.isAlive()).map(c => c._id);

  const deadFriendlyIds = myTeam.filter(c => !c.isAlive()).map(c => c._id);
  const deadEnemyIds = enemyTeam.filter(c => !c.isAlive()).map(c => c._id);

  //Only can target myself
  if (model.targetType === "only-me") {
    return [casterId]; //["myId"]
  }
  //Can target ONE opponent
  if (model.targetType === "single-opponent") {
    if (model.targetMustBeDead) {
      return deadEnemyIds;
    }

    return aliveEnemyIds; //["myOpponent1","myOpponent1"]
  }

  //Can target ONE ally (includes me as an option)
  if (model.targetType === "single-ally") {
    if (model.targetMustBeDead) {
      return deadFriendlyIds;
    }
    return aliveFriendlyIds; //["myId","myFriend1","myFriend2"]
  }

  //Can only target ENTIRE opponent team
  if (model.targetType === "opponent-team") {
    //TODO: Might need "even if they are dead" flag. -> Stealing items, etc. This would not target dead people to steal or bug items. might cause problems?

    //Some moves can target both dead and alive (item stuff)
    if (model.targetCanBeDead) {
      const conjoinedAllEnemies = [...deadEnemyIds, ...aliveEnemyIds].join(",");
      return [conjoinedAllEnemies];
    }

    return [aliveEnemyIds.join(",")]; //["myOpponent1,myOpponent2"]... notice the comma delimited string
  }
  //Can only target ENTIRE friendly team
  if (model.targetType === "ally-team") {
    if (model.targetMustBeDead) {
      //Only dead friends...
      return [deadFriendlyIds.join(",")]; //["myId", "myFriend1,myFriend2"]... notice the comma delimited string
    }

    return [aliveFriendlyIds.join(",")]; //["myId", "myFriend1,myFriend2"]... notice the comma delimited string
  }

  //Get ALL (Commit, etc)
  if (model.targetType === "all") {
    return [Object.keys(combatants).join(",")];
  }

  console.warn("no return in getTarget", model.targetType, model);
}



// WEBPACK FOOTER //
// ./src/battle/get-targets.js